import { $api } from "@client/lib/trpc";
import { useUserStore } from "@client/stores";
import type { RouteRecordNameGeneric, Router } from ".";
import { layouts } from "@client/layouts";
const publicRoutes: RouteRecordNameGeneric[] = ["home", "login", "register", "leaderboard"];

export function initializeMiddlewares(router: Router) {
	router.beforeEach(async function checkAuthntication(to) {
		const userStore = useUserStore();
		async function checkAuth() {
			if (userStore.isAuth) {
				if (userStore.user?.id) return;
				//TODO: Huge security issue. Do not store user data in local storage. Always assume it's compromised.
				const localUser = localStorage.getItem("data");
				localUser
					? userStore.saveCredentials(JSON.parse(localUser))
					: userStore.saveCredentials(await $api.user.profile.query());
			}
		}

		await checkAuth();
		userStore.isAuth = await $api.auth.isAuth.query(); //If not authenticated locally, ask the server.

		if (!userStore.isAuth && !publicRoutes.includes(to?.name)) return "/login"; //If still not authenticated and not authenticating route, redirect to home.

		await checkAuth();

		if (
			userStore.isAuth &&
			(to.name === "login" || to.name === "home" || to.name === "register")
		)
			return { name: "lobby" }; //If authenticated and trying to access home, redirect to lobby.
	});

	router.beforeEach(async function changeMetaDescrition(to) {
		const {
			description = "GAMIFIED LEARNING- MULTIPLAYER MEDICAL LEARNING PLATFORM STEP 1/2 EXAMS" as string,
		} = to?.meta || {};

		// document.title = title as string;
		const descriptionElement = document.querySelector('head meta[name="description"]');
		if (descriptionElement) descriptionElement.setAttribute("content", description as string);
	});

	router.beforeEach(function loadLayout(to) {
		to.meta.layoutComponent = layouts[to?.meta?.layout || "Default"];
	});
}

// if (!to.meta.layoutComponent) to.meta.layoutComponent = layouts.Default;

// try {
// 	to.meta.layoutComponent = (
// 		await import(
// 			to?.meta?.layout
// 				? `../layouts/${to?.meta?.layout}.vue`
// 				: `../layouts/Default.vue`
// 		)
// 	).default;
// } catch (e) {
// 	// console.error("Error loading layout", e);
// 	to.meta.layoutComponent = (await import(`../layouts/Default.vue`)).default;
// }
